import { InjectionToken } from '@angular/core';
import { currentApp, SgAppConfig } from '../app-bootstrap';

export const APP_CONFIG = new InjectionToken<SgAppConfig>('SgApplicationConfiguration', {
  providedIn: 'root',
  factory: () => currentApp,
});
